interface AboutSchema {
    pageTitle: string;
    pageDescription: string;
    pageKeywords: string;
    canonicalUrl: string;
    aboutSchema: {
        "@context": string;
        "@type": string;
        name: string;
        description: string;
        url: string;
        telephone: string;
        address: {
            "@type": string;
            addressLocality: string;
            addressRegion: string;
            addressCountry: string;
        };
        serviceType: string[];
        areaServed: string;
    };
    aboutSchemaJson: string;
}

const pageTitle = "About MASA HILLS Health Services | Trusted Home Care Agency Dallas";
const pageDescription = "Learn about MASA HILLS Health Services, a trusted home care agency serving Dallas-Fort Worth with over a decade of experience in elderly care and senior care services.";
const pageKeywords = "home care agency, senior care agency, elderly care Dallas, home care for seniors, experienced caregivers";
const canonicalUrl = "https://masahillshealthservices.com/about";

const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "MASA HILLS Health Services",
    "description": "Trusted home care agency in Dallas-Fort Worth with over a decade of experience in elderly care and senior care services.",
    "url": "https://masahillshealthservices.com/about",
    "telephone": "+14695730176",
    "address": {
        "@type": "3410 Texas Dr, Sachse, TX 75048",
        "streetAddress": "3410 Texas Dr",
        "addressLocality": "Sachse",
        "addressRegion": "TX",
        "postalCode": "75048",
        "addressCountry": "US"
    },
    "serviceType": [
        "Home Care Services",
        "Elderly Care",
        "Senior Care"
    ],
    "areaServed": "Dallas-Fort Worth, Texas"
};

const aboutSchemaJson = JSON.stringify(aboutSchema, null, 2);
const AboutSchemaData: AboutSchema = {
    pageTitle,
    pageDescription,
    pageKeywords,
    canonicalUrl,
    aboutSchema,
    aboutSchemaJson
};

export default AboutSchemaData;